import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NouisliderModule } from 'ng2-nouislider';
import { TagInputModule } from 'ngx-chips';
import { SelectDialogComponent } from './select-dialog/select-dialog.component';
import { MaterialDesignModule } from '../material.module';
import { TranslateSharedModule } from '../translate/translate.module';
import { AsapUploadModule } from 'asap-upload';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NouisliderModule,
    TagInputModule,
    RouterModule,
    MaterialDesignModule,
    TranslateSharedModule,
    AsapUploadModule,
  ],
  declarations: [
    SelectDialogComponent
  ],
  exports: [
    SelectDialogComponent,
    TranslateSharedModule,
    AsapUploadModule
  ],
  entryComponents: [
    SelectDialogComponent
  ]
})

export class SharedModule {
}
